import { useState } from "react"
import { EducationExchangeProgramModel } from "../models/EducationExchangeProgramModel"
import { EducationSchoolModel } from "../models/EducationSchoolModel"
import EducationExchangeProgram from "./List/EducationExchangeProgram"
import EducationSchool from "./List/EducationSchool"
import { CertificateSpecializationModel } from "../models/CertificateSpecializationModel"
import CertificateSpecialization from "./List/CertificateSpecialization"
import { CertificateCourseModel } from "../models/CertificateCourseModel"
import CertificateCourse from "./List/CertificateCourse"
import { CertificateTestScoreModel } from "../models/CertificateTestScoreModel"
import CertificateTestScore from "./List/CertificateTestScore"
import ListTemplate from "./List/ListTemplate"

function EducationCertificate() {
    const [showAllCoursework, setShowAllCoursework] = useState(false)

    const specializationCount = CertificateSpecializationModel.length
    const courseCount = CertificateCourseModel.length
    const FilteredCertificateTestScoreModel = CertificateTestScoreModel.filter((testScore) => testScore.expiredDate > new Date())

    return (
        <div>
            <big className="section-header">Education & Certificates</big>
            <ListTemplate component={EducationSchool} data={EducationSchoolModel} sectionTitle="Education Background"/>
            <ListTemplate component={EducationExchangeProgram} data={EducationExchangeProgramModel} sectionTitle="Participated Exchange Program"/>
            <ListTemplate component={CertificateSpecialization} data={CertificateSpecializationModel} sectionTitle={`Specialization(${specializationCount})`}/>
            <ListTemplate component={CertificateTestScore} data={FilteredCertificateTestScoreModel} sectionTitle={`Test Score(${FilteredCertificateTestScoreModel.length})`}/>
            {showAllCoursework
                ? <ListTemplate component={CertificateCourse} data={CertificateCourseModel} sectionTitle={`Coursework(${courseCount})`}/>
                : <div className="section-detail">
                    <button className="coursework-toggle" onClick={() => setShowAllCoursework(true)}>
                        Show all coursework ({courseCount})
                    </button>
                  </div>
            }
        </div>
    )
}

export default EducationCertificate
